import React from 'react'

const BackDrop = ({onClick}:{onClick?: ()=>void}) => {
  return (
    <div onClick={() => onClick && onClick()} className="activity-modal"></div>
  )
}

export default BackDrop
